
import { Component } from "vue-property-decorator"
import ValueBasedFormsMixin from "@/components/forms/FormsMixin"

@Component({components : {}})
export default class JobTemplateForm extends ValueBasedFormsMixin {
  getHalFormName() : string { return "jobtemplate" }
}
